var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rows==0)?_c('div',[(_vm.isFiltered)?_c('div',{staticClass:"no-data"},[_c('p',[_vm._v(_vm._s(_vm.searchTitle))])]):_c('div',{staticClass:"no-data"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.to)?_c('router-link',{staticClass:"btn btn-w-shadow btn-standart-2",attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.addTitle))]):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }